import { IWeeklyMenu } from 'types';
import { COLLECTIONS } from 'constants/collections';
import { updateDocument, createDocument } from 'utils/firebase';

export const create = (data: Partial<IWeeklyMenu>) => {
  return createDocument({ collection: COLLECTIONS.WEEKLY_MENU, data });
};

export const update = (id: string, data: Partial<IWeeklyMenu>) => {
  return updateDocument({ collection: COLLECTIONS.WEEKLY_MENU, id, data });
};
